<template>
  <div>
    <v-app class="app-tabela">
      <div class="box" style="margin-top: 0px">
        <v-card class="tabela">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              class="input-bottom"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            @pagination="getPagination"
            :page="currentPage"
            :footer-props="{
              itemsPerPageText: '',
              'items-per-page-options': [10],
              'disable-items-per-page': true,
            }"
            :loading="loading"
            loading-text="Carregando, Por favor espere"
            :headers="headers"
            :items="indexedItems"
            :search="search"
            item-key="id"
            class="elevation-1"
            show-expand
            :single-expand="true"
            :expanded.sync="expanded"
          >
            <template v-slot:item.no_profissional="{ item }">
              {{ item.no_profissional }}
              <span v-if="item.st_lotacao_ativa == 0" class="st-lotacao-inativa"
                >Sem lotação ativa</span
              >
            </template>

            <!-- <template #footer.prepend>
                    <v-spacer />
                  </template> -->
            <template v-slot:expanded-item="{ headers, item }">
              <td colspan="9">
                <table class="table table-interna">
                  <thead>
                    <tr>
                      <th>CNES</th>
                      <th>Unidade de saúde</th>
                      <th>INE</th>
                      <th>Equipe</th>
                      <th>Inativação</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in item.lotacoes" :key="index">
                      <td>
                        {{ item.nu_cnes }}
                      </td>
                      <td>
                        {{ item.no_unidade_saude }}
                      </td>
                      <td>{{ item.nu_ine }}</td>
                      <td>
                        {{ item.no_equipe }}
                      </td>
                      <td>
                        {{
                          item.dt_desativacao != null
                            ? formatDate(item.dt_desativacao)
                            : ''
                        }}
                      </td>
                      <td>{{ item.st_ativo == 1 ? 'Ativo' : 'Inativo' }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </template>

            <template v-slot:[`footer.page-text`]="items">
              <div class="info-table-item tabela-esus-pec">
                <FonteSincronizadorC />
              </div>
              <span class="paginacao"
                >{{ items.pageStart }} - {{ items.pageStop }} de
                {{ items.itemsLength }} registros</span
              >
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="blue"
                :height="10"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:no-data>
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
            <template v-slot:no-results style="padding: 0px">
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-app>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  components: {},
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      search: '',
      expanded: [],
      headers: [
        {
          text: 'Profissional',
          align: 'start',
          filterable: true,
          value: 'no_profissional',
        },
        {
          text: 'CNS',
          align: 'start',
          filterable: true,
          value: 'nu_cns',
        },
        {
          text: 'CPF',
          align: 'start',
          filterable: true,
          value: 'nu_cpf',
        },
        {
          text: 'CBO',
          align: 'start',
          filterable: true,
          value: 'no_cbo',
        },
        { text: '', value: 'data-table-expand' },
      ],
      currentPage: 1,
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => {
        let lotacoes = []

        if (item.lotacoes) {
          try {
            lotacoes =
              typeof item.lotacoes === 'string'
                ? JSON.parse(item.lotacoes)
                : item.lotacoes
          } catch (e) {
            lotacoes = []
          }
        }

        return {
          ...item,
          id: index,
          lotacoes,
        }
      })
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },
  },
}
</script>

<style lang="scss" scoped>
#profissionais-lotacoes {
  .st-lotacao-inativa {
    background: #d4d4db;
    border-radius: 20px;
    padding: 5px 10px;
    font-weight: 700;
    font-size: 11px;
  }
}
</style>
